import React from "react";
import { Form } from "antd";

import { InputPhone, InputPhoneWithPhoneTypeAddon } from "../InputPhone";
import { phoneNumberLengthRegEx } from "../../../../../utils/form/validation";
import { MobileOutlined, PhoneOutlined, PrinterOutlined } from "@ant-design/icons";
import { BLACK } from "../../../../../constant/colors";

const addonBeforeIcons = Object.freeze({
  FAX: PrinterOutlined,
  HOME: PhoneOutlined,
  MOBILE: MobileOutlined
});

const getAddonBeforeIcon = (addonBefore) => {
  const Icon = addonBeforeIcons[addonBefore] || null;
  return Icon ? <Icon style={{ color: BLACK }} /> : null;
};

export const PhoneNumberFormItem = ({
  name,
  label,
  required,
  rules = [],
  placeholder,
  typeName,
  style = { display: "flex" },
  addon = true,
  addonBefore,
  formItemProps = {}
}) => (
  <Form.Item
    rules={[{ required, message: "" }, { pattern: phoneNumberLengthRegEx, message: "" }, ...rules]}
    name={name}
    label={label}
    {...formItemProps}
  >
    {addon ? (
      <InputPhoneWithPhoneTypeAddon placeholder={placeholder} typeName={typeName} style={style} />
    ) : (
      <InputPhone placeholder={placeholder} style={style} addonBefore={getAddonBeforeIcon(addonBefore)} />
    )}
  </Form.Item>
);
